var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8655846,15.8100496 L4.18995035,9.1344154 C3.86802329,8.81245479 3.86802329,8.29050156 4.18995035,7.96857449 L4.96855295,7.18997189 C5.28997685,6.86854799 5.8108902,6.86794419 6.13305208,7.18859656 L11.4485218,12.4791427 L16.763958,7.18859656 C17.0861199,6.86794419 17.6070333,6.86854799 17.9284572,7.18997189 L18.7070598,7.96857449 C19.0289868,8.2905351 19.0289868,8.81248834 18.7070598,9.1344154 L12.0314591,15.8100496 C11.7094984,16.1319767 11.1875452,16.1319767 10.8655846,15.8100496 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "arrow-left",
    fill: "#000000",
    fillRule: "nonzero",
    transform: "translate(11.448505, 11.500000) rotate(90.000000) translate(-11.448505, -11.500000) ",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4c193f5d.svg";
export { ForwardRef as ReactComponent };